import React from "react";
import * as Icons from "lucide-react";
import { FREQUENCES, CLOUD_TIMELINE } from "../mock";
import { useReveal } from "../hooks/useReveal";

function FreqCard({ f, i }) {
  const ref = useReveal();
  const wide = i === 5;
  return (
    <div
      ref={ref}
      className={`reveal group relative rounded-2xl overflow-hidden glass card-lift ${
        wide ? "md:col-span-2 lg:col-span-1" : ""
      }`}
    >
      <div className="relative h-56 overflow-hidden">
        <img
          src={f.image}
          alt={f.title}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#070d1c] via-[#070d1c]/40 to-transparent" />
      </div>
      <div className="p-6 -mt-10 relative">
        <h4 className="text-xl text-white leading-snug notranslate" translate="no">{f.title}</h4>
        <p className="mt-3 text-sm text-white/65 leading-relaxed">{f.text}</p>
      </div>
    </div>
  );
}

export default function Frequences() {
  const head = useReveal();
  const quote = useReveal();
  return (
    <section id="frequences" className="relative py-24 md:py-28 ocean-bg">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div ref={head} className="reveal text-center max-w-3xl mx-auto">
          <p className="eyebrow text-[#7fd8e8] text-xs mb-4">Fréquences vibratoires</p>
          <h2 className="text-4xl md:text-5xl text-white leading-tight">
            De puissantes fréquences vibratoires <span className="text-gold">reçues par canalisation</span>
          </h2>
          <p className="mt-5 eyebrow text-white/50 text-xs">
            C'est en t'y connectant qu'elles vont te permettre :
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {FREQUENCES.map((f, i) => (
            <FreqCard key={f.title} f={f} i={i} />
          ))}
        </div>

        {/* CLOUD & TIMELINE */}
        <div className="mt-24 text-center">
          <p className="eyebrow text-[#7fd8e8] text-xs mb-4">Le mécanisme signature</p>
          <h3 className="text-4xl md:text-5xl text-gold notranslate" translate="no">Cloud &amp; Timeline</h3>
        </div>
        <div className="mt-10 grid md:grid-cols-3 gap-6">
          {CLOUD_TIMELINE.map((c, i) => {
            const Icon = Icons[c.icon] || Icons.Sparkles;
            return (
              <CloudCard key={c.title} c={c} Icon={Icon} i={i} />
            );
          })}
        </div>

        <div ref={quote} className="reveal mt-14 max-w-3xl mx-auto text-center">
          <p className="text-2xl md:text-3xl font-[Cormorant_Garamond] italic text-white/90 leading-relaxed">
            « Tu peux travailler sur tes croyances pendant des années… ou changer de fréquence en quelques instants. »
          </p>
        </div>
      </div>
    </section>
  );
}

function CloudCard({ c, Icon, i }) {
  const ref = useReveal();
  return (
    <div ref={ref} className={`reveal reveal-delay-${i + 1} glass card-lift rounded-2xl p-7`}>
      <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#5a5ee0]/40 to-[#1f6f8b]/30 flex items-center justify-center ring-1 ring-white/10 mb-5">
        <Icon className="w-6 h-6 text-[#7fd8e8]" />
      </div>
      <h4 className="text-2xl text-white mb-3">{c.title}</h4>
      <p className="text-sm text-white/65 leading-relaxed">{c.text}</p>
    </div>
  );
}
